"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _ramda = require("ramda");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

var _dnd = require("../../utils/dnd");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    * {\n        margin: 0;\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 0.5rem 24px 0.5rem 0.5rem;\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n    border: 1px dashed #eee;\n    background: #f3f3f3;\n    position: relative;\n    font-weight: bold;\n    @media (max-width: 767px) {\n        font-size: 13px;\n        padding: 0.5rem;\n    }\n    @media (min-width: 768px) {\n        &:before {\n            content: '';\n            background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZmlsbD0ibm9uZSIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB3aWR0aD0iNDgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkgMTBDMTkgMTIuMjA5MSAxNy4yMDkxIDE0IDE1IDE0QzEyLjc5MDkgMTQgMTEgMTIuMjA5MSAxMSAxMEMxMSA3Ljc5MDg2IDEyLjc5MDkgNiAxNSA2QzE3LjIwOTEgNiAxOSA3Ljc5MDg2IDE5IDEwWk0xNSAyOEMxNy4yMDkxIDI4IDE5IDI2LjIwOTEgMTkgMjRDMTkgMjEuNzkwOSAxNy4yMDkxIDIwIDE1IDIwQzEyLjc5MDkgMjAgMTEgMjEuNzkwOSAxMSAyNEMxMSAyNi4yMDkxIDEyLjc5MDkgMjggMTUgMjhaTTE1IDQyQzE3LjIwOTEgNDIgMTkgNDAuMjA5MSAxOSAzOEMxOSAzNS43OTA5IDE3LjIwOTEgMzQgMTUgMzRDMTIuNzkwOSAzNCAxMSAzNS43OTA5IDExIDM4QzExIDQwLjIwOTEgMTIuNzkwOSA0MiAxNSA0MloiIGZpbGw9ImJsYWNrIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNyAxMEMzNyAxMi4yMDkxIDM1LjIwOTEgMTQgMzMgMTRDMzAuNzkwOSAxNCAyOSAxMi4yMDkxIDI5IDEwQzI5IDcuNzkwODYgMzAuNzkwOSA2IDMzIDZDMzUuMjA5MSA2IDM3IDcuNzkwODYgMzcgMTBaTTMzIDI4QzM1LjIwOTEgMjggMzcgMjYuMjA5MSAzNyAyNEMzNyAyMS43OTA5IDM1LjIwOTEgMjAgMzMgMjBDMzAuNzkwOSAyMCAyOSAyMS43OTA5IDI5IDI0QzI5IDI2LjIwOTEgMzAuNzkwOSAyOCAzMyAyOFpNMzMgNDJDMzUuMjA5MSA0MiAzNyA0MC4yMDkxIDM3IDM4QzM3IDM1Ljc5MDkgMzUuMjA5MSAzNCAzMyAzNEMzMC43OTA5IDM0IDI5IDM1Ljc5MDkgMjkgMzhDMjkgNDAuMjA5MSAzMC43OTA5IDQyIDMzIDQyWiIgZmlsbD0iYmxhY2siIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==');\n            display: inline-block;\n            width: 16px;\n            height: 16px;\n            background-size: 16px;\n            position: absolute;\n            right: 4px;\n            opacity: .6;\n        }\n    }\n    &.is-audit  {\n        color: #549E38;\n        &:before {\n            opacity: 1;\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='10' viewBox='0 0 12 10' fill='none'%3E%3Cpath d='M11.4687 0.597656H10.5131C10.3791 0.597656 10.2519 0.65918 10.1699 0.764453L4.53298 7.90527L1.83006 4.48047C1.78917 4.42855 1.73705 4.38658 1.67761 4.35769C1.61818 4.3288 1.55297 4.31375 1.48689 4.31367H0.531227C0.439625 4.31367 0.38904 4.41895 0.445094 4.49004L4.18982 9.23418C4.36482 9.45566 4.70115 9.45566 4.87752 9.23418L11.5549 0.772656C11.6109 0.70293 11.5603 0.597656 11.4687 0.597656Z' fill='%23549E38'/%3E%3C/svg%3E\");\n        }\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        &:before {\n            content: ", ";\n            position: absolute;\n            color: #ddd;\n            font-size: 16px;\n            left: 50%;\n            top: 50%;\n            transform: translate(-50%,-50%);\n        }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 50%;\n    position: relative;\n    padding: 0.75rem 1.25rem;\n    border: 2px solid #eee;\n    @media (max-width: 767px) {\n        padding: 0.2rem 0.5rem;\n    }\n    /* margin-right: ", "px;\n    margin-left: ", "px; */\n    ", "\n    &:last-child {\n        border-left-width: 0;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    position: relative;\n    &:before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 24px;\n        height: 24px;\n        margin: -14px;\n        background-color: #fff;\n        border: 2px solid #eeeeee;\n        background-image: url(\"data:image/svg+xml,%3Csvg style='enable-background:new 0 0 50 50;' version='1.1' viewBox='0 0 50 50' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Layer_1'%3E%3Cpath d='M9.465,37.95l8.242-8.243l-1.414-1.414l-8.242,8.242C7.105,37.48,5.85,38,4.515,38H1v2h3.515 C6.384,40,8.142,39.272,9.465,37.95z'/%3E%3Cpath d='M32.535,12.05l-8.242,8.243l1.414,1.414l8.242-8.242C34.895,12.52,36.15,12,37.485,12h6.101l-4.293,4.293l1.414,1.414 L47.414,11l-6.707-6.707l-1.414,1.414L43.586,10h-6.101C35.616,10,33.858,10.728,32.535,12.05z'/%3E%3Cpath d='M8.051,13.464L32.535,37.95c1.323,1.322,3.081,2.05,4.95,2.05h6.101l-4.293,4.293l1.414,1.414L47.414,39l-6.707-6.707 l-1.414,1.414L43.586,38h-6.101c-1.335,0-2.591-0.52-3.536-1.464L9.465,12.05C8.142,10.728,6.384,10,4.515,10H1v2h3.515 C5.85,12,7.105,12.52,8.051,13.464z'/%3E%3C/g%3E%3Cg/%3E%3C/svg%3E\");\n        background-size: 20px;\n        background-position: center;\n        background-repeat: no-repeat;\n        z-index: 1;\n        @media (max-width: 767px) {\n            width: 16px;\n            height: 16px;\n            margin: -8px;\n            background-size: 14px;\n            border: 1px solid #eeeeee;\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents["default"].div(_templateObject());

var List = _styledComponents["default"].div(_templateObject2(), function (_ref) {
  var list = _ref.list;
  return list ? 5 : 0;
}, function (_ref2) {
  var list = _ref2.list;
  return list ? 0 : 5;
}, function (_ref3) {
  var showPlaceholder = _ref3.showPlaceholder;
  return showPlaceholder && (0, _styledComponents.css)(_templateObject3(), function (_ref4) {
    var placeholderMessage = _ref4.placeholderMessage;
    return "".concat(placeholderMessage || 'Перетащите сюда');
  });
});

var Item = _styledComponents["default"].div(_templateObject4());

var ItemText = _styledComponents["default"].div(_templateObject5());

var Ranging = /*#__PURE__*/function (_Component) {
  _inherits(Ranging, _Component);

  var _super = _createSuper(Ranging);

  function Ranging(props) {
    var _this;

    _classCallCheck(this, Ranging);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (result) {
      var source = result.source,
          destination = result.destination;

      var valuesList = _this.getValuesList();

      if (!destination) {
        return;
      }

      if (source.droppableId === destination.droppableId) {
        var isList = source.droppableId === 'list';
        var items = (0, _dnd.reorder)(isList ? _this.state.list : valuesList, source.index, destination.index);

        if (isList) {
          _this.setState({
            list: items
          });
        } else {
          _this.props.onChange(items.map(function (i) {
            return i.id;
          }));
        }
      } else {
        var sourceItems = source.droppableId === 'list' ? _this.state.list : valuesList;
        var destinationItems = destination.droppableId === 'list' ? _this.state.list : valuesList;
        var data = (0, _dnd.move)(sourceItems, destinationItems, source, destination);

        _this.setState({
          list: data.list
        });

        _this.props.onChange((data.values || data.list).map(function (i) {
          return i.id;
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getValuesList", function () {
      var _this$props = _this.props,
          value = _this$props.input.value,
          options = _this$props.options;
      return (value || []).map(function (id) {
        return (0, _ramda.find)((0, _ramda.propEq)('id', id), options);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDroppable", function (provided, list) {
      var items = list ? _this.state.list : _this.getValuesList();
      return /*#__PURE__*/_react["default"].createElement(List, {
        ref: provided.innerRef,
        showPlaceholder: !list && !items.length,
        list: list,
        placeholderMessage: _this.props.placeholderMessage
      }, items.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
          key: item.id,
          draggableId: item.id,
          index: index,
          isDragDisabled: _this.props.disabled
        }, function (provided) {
          return /*#__PURE__*/_react["default"].createElement("div", _extends({
            ref: provided.innerRef
          }, provided.draggableProps, provided.dragHandleProps, {
            style: _objectSpread({
              marginBottom: 5
            }, provided.draggableProps.style)
          }), /*#__PURE__*/_react["default"].createElement(Item, {
            className: _this.props.isAudit && !list ? 'is-audit' : ''
          }, /*#__PURE__*/_react["default"].createElement(ItemText, {
            dangerouslySetInnerHTML: {
              __html: item.title
            }
          })));
        });
      }), provided.placeholder);
    });

    _this.state = {
      list: props.disabled ? (0, _ramda.sortBy)((0, _ramda.prop)('title'), props.options) : (0, _ramda.filter)(function (i) {
        return !(0, _ramda.contains)(i.id, props.input.value || []);
      }, props.options)
    };
    return _this;
  }

  _createClass(Ranging, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
        onDragEnd: this.onDragEnd
      }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
        droppableId: "list"
      }, function (provided) {
        return _this2.renderDroppable(provided, true);
      }), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
        droppableId: "values"
      }, function (provided) {
        return _this2.renderDroppable(provided);
      })));
    }
  }]);

  return Ranging;
}(_react.Component);

_defineProperty(Ranging, "defaultProps", {
  options: [],
  isAudit: false
});

var _default = (0, _withFieldWrapper["default"])(Ranging);

exports["default"] = _default;